import {Component, Mixins} from "vue-property-decorator";
import ControlPocProprietaire from "../../../components/poc/control-proprietaires";
import ControlPocRefCadastrale from "../../../components/poc/control-ref-cadastrales";
import ControlPocAccesPossible from "../../../components/poc/control-access-possibles";
import ControlPocPilliers from "../../../components/poc/control-pilliers";
import ControlPocTauxDefruitement from "../../../components/poc/control-taux-defruitement";
import ControlPocDescriptionSommaire from "../../../components/poc/control-description-sommaire";
import ControlPocEnjeuxSurface from "../../../components/poc/control-enjeux-surface";
import ControlPocObservationChiropteres from "../../../components/poc/control-observation-chiropteres";
import ControlCavDocuments from "../../../components/control-documents";
import ControlCavPhotos from "../../../components/control-photos";
import ControlPocScans from "../../../components/poc/control-scans";
import ControlPocEvenementsObservations from "../../../components/poc/control-evenements-observations";
import ControlPocSuivis from "../../../components/poc/control-suivis";
import ControlPocPreconisations from "../../../components/poc/control-preconisations";

import { State, Getter } from 'vuex-class';
import CavCavite from '@/lib/models/cav-cavite';

import XTextarea from '@/components/x-textarea';
import { FLEX_PROFILES } from '@/lib/models/user';
import RightsAware from '@/lib/mixins/rights-aware';

@Component
export default class PartPocMain extends Mixins(RightsAware) {

  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  @Getter userhHasHigherFlexProfileThan;

  created() {
    this.readonly_ = !this.userhHasHigherFlexProfileThan(FLEX_PROFILES.POC_LECTEUR);
  }

  render() {
    return (
      <div class="main-tab-inner">
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="label is-small has-text-weight-normal">
                <i>Cet espace vous permet d'apporter des informations supplémentaires sur la cavité POC.</i>
              </label>
            </div>
            <div class="field">
              <label class="label is-small">Informations complémentaires</label>
              <div class="control">
                <XTextarea vModel={this.data.pocInfosComplementaires} class="textarea is-small" rows={2}/>
              </div>
            </div>
            <div class="field">
              <label class="label is-small">Propriétaires</label>
              <ControlPocProprietaire collection={this.data.proprietaires} />
            </div>

            <div class="field">
              <label class="label is-small">Références cadastrales</label>
              <ControlPocRefCadastrale collection={this.data.refCadastrales} />
            </div>

            <div class="field">
              <label class="label is-small">Accès possibles</label>
              <ControlPocAccesPossible collection={this.data.accesPossibles} />
            </div>

            <div class="field">
              <label class="label is-small">Piliers</label>
              <ControlPocPilliers collection={this.data.piliers} />
            </div>

            <div class="field">
              <label class="label is-small">Taux de défruitement</label>
              <ControlPocTauxDefruitement collection={this.data.tauxDefruitements} />
            </div>

            <div class="field">
              <label class="label is-small">Description sommaire</label>
              <ControlPocDescriptionSommaire collection={this.data.descriptionSommaires} />
            </div>

            <div class="field">
              <label class="label is-small">Enjeux en surface</label>
              <ControlPocEnjeuxSurface collection={this.data.enjeuxSurfaces} />
            </div>

            <div class="field">
              <label class="label is-small">Observation de chiroptères</label>
              <ControlPocObservationChiropteres collection={this.data.observationChiropteres} />
            </div>

            <div class="field">
              <label class="label is-small">Documents</label>
              <ControlCavDocuments collection={this.data.documents} />
            </div>

            <div class="field">
              <label class="label is-small">Photos</label>
              <ControlCavPhotos collection={this.data.photos} />
            </div>

            <div class="field">
              <label class="label is-small">Scans</label>
              <ControlPocScans collection={this.data.scans} />
            </div>

            <div class="field">
              <label class="label is-small">Evénements/observations</label>
              <ControlPocEvenementsObservations collection={this.data.evenementObservations} />
            </div>

            <div class="field">
              <label class="label is-small">Suivis</label>
              <ControlPocSuivis collection={this.data.suivis} />
            </div>

            <div class="field">
              <label class="label is-small">Préconisations</label>
              <ControlPocPreconisations collection={this.data.preconisations} />
            </div>
          </div>
        </div>
      </div>
    );
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-743aeb60/index.tsx" });